import { ManualRiskAdjustmentKind } from '../../app/modules/clients/core/_rest_models'

export const FLAGS_SELECT = 'flags_select'

export const HAS_COMMENT_OPTIONS = [
  { value: '', label: 'Все' },
  { value: 'true', label: 'С комментарием' },
  { value: 'false', label: 'Без комментария' },
]

export const MANUAL_RISK_ADJUSTMENT_OPTIONS: Array<{
  value: ManualRiskAdjustmentKind
  label: string
}> = [
  { value: 'permanent', label: 'Бессрочная' },
  { value: 'temporary', label: 'Временная' },
]
